export class NotificionesModel {
    body: string;
    title: string;
    codemple: string;
    sound: string;
    id_mensaje: string;
    leido: boolean;
    date: Date;
    constructor(data: any) {
        if ("aps.alert.title" in data && "aps.alert.body" in data) {
            this.body = data["aps.alert.body"];

            this.title = data["aps.alert.title"];
        } else {
            this.body = data.Body;
            this.title = data.Title;
        }
        this.codemple = data.Codemple;
        this.sound = data.Sound;
        this.id_mensaje = data.NotificationId;
        this.leido = false;
        this.date = new Date(data.FechaRecibido.replace(/([+-]\d{2}:\d{2}|Z)$/, ''));

    }
}